import DonutChart, { DonutChartProps } from "./DonutChart";
import PieChartComponent, { PieChartProps } from "./PieChart";
import LineChartComponent, { LineChartProps } from "./LineChart";
import RadarChartComponent, { RadarChartProps } from "./RadarChart";
import BarChartComponent, { BarChartProps } from "./BarChart";

const variants = {
  donut: DonutChart,
  pie: PieChartComponent,
  line: LineChartComponent,
  radar: RadarChartComponent,
  bar: BarChartComponent
};
export type ChartVariant = keyof typeof variants;

export type ChartComponentProps =
  | ({ variant: "donut" } & DonutChartProps)
  | ({ variant: "pie" } & PieChartProps)
  | ({ variant: "line" } & LineChartProps)
  | ({ variant: "radar" } & RadarChartProps)
  | ({ variant: "bar" } & BarChartProps);

export type ChartData = {
  name: string;
  value: number;
  label?: number;
  disabled?: boolean;
  fixedSegment?: boolean;
}[];

const Chart = ({ variant, ...props }: ChartComponentProps) => {
  const ChartComponent = variants[variant];
  return <ChartComponent {...(props as any)} />;
};

export default Chart;
